import * as THREE from 'three'
import { OrbitControls as ThreeOrbitControls } from 'three/addons/controls/OrbitControls.js'
import type { Object3D } from 'three'

class OrbitControls extends ThreeOrbitControls {
  /**
   * Sets the target of the controls based on the position of the object being passed in
   * @param object ThreeJS Object3D Object
   */
  setTargetByObjectPosition(object: Object3D) {
    const objectWorldPosition = new THREE.Vector3()
    object.getWorldPosition(objectWorldPosition)
    //TODO Research why target is being marked as a non-existent property when it does exist
    this.target.set(objectWorldPosition.x, objectWorldPosition.y, objectWorldPosition.z)
  }
}

export { OrbitControls }
